export const variants = {
  plus: 'nostalgie-plus',
};
